import { useMemo } from "react";

export const useGroupedFlights = (enabled, menuItems, isTrainingMode = false) => {
    return useMemo(() => {
        if (!enabled) return {};
        const flights = Array.isArray(menuItems) ? menuItems : [];

        const grouped = flights.reduce((acc, flight) => {
            let key;
            if (isTrainingMode) {
                // Group by simulator block
                const simBlock = flight?.sSimBlock_Seq?.[0];
                key = simBlock || "No Sim Block";
            } else {
                // Group by date
                key = flight.flightDate || "N/A";
            }
            acc[key] = acc[key] ? [...acc[key], flight] : [flight];
            return acc;
        }, {});

        Object.keys(grouped).forEach((k) => {
            grouped[k] = grouped[k]
                .slice()
                .sort(
                    (a, b) => new Date(a?.departureDateTime) - new Date(b?.departureDateTime)
                );
        });
        return grouped;
    }, [enabled, menuItems, isTrainingMode]);
};

export default useGroupedFlights;


